import React, { useCallback, useEffect } from "react";
import { Card } from "antd";
import Title from "antd/es/typography/Title";
import FunnelChart from "./components/BookingFunnelChart";
import { bookingFunnel } from "../ducks/service";
import LoaderTsx from "../../../Loader.tsx";
import { useFetchAsync } from "../../../../../hooks/useFetchAsync";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";
import { useQuery } from "@tanstack/react-query";

const BookingFunnelMain: React.FC = React.memo(() => {
  const filterData = useDashboardFilterContext();
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["bookingFunnel", filterData?.queryParams],
    queryFn: () =>
      bookingFunnel(filterData?.queryParams && filterData?.queryParams),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // disable auto refetch when window regains focus
  });
  // whenever queryParams changes, trigger refetch
  // useEffect(() => {
  //   if (filterData?.queryParams) {
  //     refetch();
  //   }
  // }, [filterData?.queryParams, refetch]);

  return (
    <Card
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: 20,
        border: "1px solid #E9E9E9",
        boxShadow: "none",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title
          level={5}
          style={{
            margin: 0,
            color: "#1F5782",
            textTransform: "uppercase",
            fontWeight: 400,
          }}
        >
          <span style={{ fontWeight: 700 }}>BOOKINGS</span>{" "}
          <span style={{ fontWeight: 400 }}>Funnel</span>
        </Title>
      </div>

      {isLoading ? (
        <LoaderTsx height={"30vh"} />
      ) : (
        <FunnelChart data={data?.result?.length > 0 ? data?.result : []} />
      )}
    </Card>
  );
});

export default BookingFunnelMain;
